export interface CookieConsent {
  necessary: boolean;
  timestamp: number;
}

const CONSENT_KEY = 'optiai_cookie_consent';

export const getCookieConsent = (): CookieConsent | null => {
  const stored = localStorage.getItem(CONSENT_KEY);
  if (!stored) return null;

  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

export const setCookieConsent = (consent: Omit<CookieConsent, 'timestamp'>): void => {
  const consentWithTimestamp: CookieConsent = {
    ...consent,
    timestamp: Date.now(),
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consentWithTimestamp));

  window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: consentWithTimestamp }));
};

export const clearCookieConsent = (): void => {
  localStorage.removeItem(CONSENT_KEY);
};

export const hasGivenConsent = (): boolean => {
  return getCookieConsent() !== null;
};
